import { render } from "./FileInfoButtons.vue?vue&type=template&id=3f65f112"
import script from "./FileInfoButtons.vue?vue&type=script&lang=js"
export * from "./FileInfoButtons.vue?vue&type=script&lang=js"

import "./FileInfoButtons.vue?vue&type=style&index=0&id=3f65f112&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QBtn,QCardActions});qInstall(script, 'directives', {ClosePopup});
